<template>
	<div class="incenters">
		<div style="">
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="edit"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="导入" fontSize="14px" @btnclick="importData"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="exportData"
				:src="require('@/assets/channel/export.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="举办" fontSize="14px" @btnclick="hold"
				:src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<a class="Dowload" style @click="downloadTemplate">导入模板下载</a>
		</div>
		<div style="height: 10px;"></div>
		<div class="from">
			<Commontable ref="comtable" :tableData="tableData" :headerData="headerData" :hasChecked="false"
				@handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick">
			</Commontable>
		</div>
		<div class="pagination">
			<Pagination :total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
			</Pagination>
		</div>

		<!-- Dialogs -->
		<ActivityListDialog ref="addDialog" :title="dialogTitle" :dialogVisible="dialogVisibleAdd" @cancel="cancelAdd"
			@dialogOK="dialogOKAdd">
		</ActivityListDialog>

		<ActivityConductDialog ref="conductDialog" :title="conductTitle" :dialogVisible="dialogVisibleConduct"
			@cancel="cancelConduct" @dialogOK="dialogOKConduct">
		</ActivityConductDialog>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="dialogOKDel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">
				确认要删除选中的数据吗？
			</span>
		</Dialog>

		<input type="file" ref="fileInput" style="display: none" @change="handleFileChange" accept=".xlsx,.xls" />
	</div>
</template>

<script>
	import Commontable from "@/components/common-table.vue";
	import Commonbtn from "@/components/common-btn.vue";
	import Pagination from "@/components/pagination.vue";
	import Dialog from "@/components/dialog.vue";
	import ActivityListDialog from "./ActivityListDialog.vue";
	import ActivityConductDialog from "./ActivityConductDialog.vue";
	import {
		ActivityDelete,
		ActivityExport,
		ActivityImport,
		ActivityDownloadTemplet
	} from "@/api/ActivityList";

	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			Dialog,
			ActivityListDialog,
			ActivityConductDialog
		},
		props: {
			tableData: {
				type: Array,
				default: () => []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				qx: {
					add: false,
					update: false,
					del: false,
				},
				qus: [],
				selection: [],
				headerData: [{
						prop: 'selection',
						types: 'selection',
						fixed: 'left'
					},
					{
						prop: 'ActivityName',
						label: '活动名称',
						columnwidth: 150
					},
					{
						prop: 'LEVEL2',
						label: '会议类型(L2)',
						columnwidth: 120
					},
					{
						prop: 'LEVEL3',
						label: '重点产品(L3)',
						columnwidth: 200
					},
					{
						prop: 'PreConductDate',
						label: '预计举办时间',
						columnwidth: 180
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 110
					},
					{
						prop: 'CreateTime',
						label: '创建时间',
						columnwidth: 150
					},
					{
						prop: 'ActivityCode',
						label: '活动编号',
						columnwidth: 150
					}
				],
				dialogVisibleAdd: false,
				dialogTitle: '',
				dialogVisibleDel: false,
				dialogVisibleConduct: false,
				conductTitle: '活动举办'
			};
		},
		mounted() {
			this.QX();
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"));
				data.CusWebMenus.map((item, index) => {
					if (item.NodeID == 77) {
						item.Nodes.forEach((items, indexs) => {
							if (items.NodeID == 1093) {
								items.Nodes.forEach((itemes, index) => {
									if (itemes.NodeID == 1094) {
										this.qus = itemes.Buttons
									}
								})
							}
						})
					}
				});
				console.log(this.qus);
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == "add") {
							this.qx.add = true;
						} else if (item.NodeName == "edit") {
							this.qx.update = true;
						} else if (item.NodeName == "delete") {
							this.qx.del = true;
						}
					});
				}
			},
			handleSelectionChange(val) {
				this.selection = val;
			},
			onRowClick(row) {
				this.$emit('onRowClick', row);
			},
			handleCurrentChange(val) {
				this.$emit('handleCurrentChange', val);
			},
			handleSizeChange(val) {
				this.$emit('handleSizeChange', val);
			},
			add() {
				this.dialogTitle = '新增活动';
				this.dialogVisibleAdd = true;
				this.$nextTick(() => {
					this.$refs.addDialog.init();
				});
			},
			edit() {
				if (this.selection.length !== 1) {
					this.$message.warning('请选择一条数据进行修改');
					return;
				}
				this.dialogTitle = '修改活动';
				this.dialogVisibleAdd = true;
				this.$nextTick(() => {
					this.$refs.addDialog.init(this.selection[0].ActivityCode);
				});
			},
			cancelAdd() {
				this.dialogVisibleAdd = false;
			},
			dialogOKAdd() {
				this.dialogVisibleAdd = false;
				this.$emit('reload');
			},
			del() {
				if (this.selection.length === 0) {
					this.$message.warning('请选择要删除的数据');
					return;
				}
				this.dialogVisibleDel = true;
			},
			cancelDel() {
				this.dialogVisibleDel = false;
			},
			async dialogOKDel() {
				let ids = this.selection.map(item => item
					.ActivityCode
				); // API says ActivityCodes (number?), but List returns ActivityCode (text). Assuming IDs or Codes.
				// Wait, API doc says "ActivityCodes: Number". Usually it's a list of IDs.
				// But List output says "ActivityCode: Text". 
				// I'll assume I should pass an array of codes/ids.
				// Wait, `ActivityDelete` in my API wrapper takes `data`.
				// Let's pass `ActivityCodes: [1, 2]` or similar.
				// I'll assume the selection has the ID/Code needed.

				let res = await ActivityDelete({
					ActivityCodes: this.selection.map(it => it.ActivityCode)
				});
				if (res.code == 0) {
					this.$message.success('删除成功');
					this.dialogVisibleDel = false;
					this.$emit('reload');
				} else {
					this.$message.error(res.message);
				}
			},
			importData() {
				this.$refs.fileInput.click();
			},
			async handleFileChange(e) {
				const file = e.target.files[0];
				if (!file) return;
				const formData = new FormData();
				formData.append('file', file);

				const loading = this.$loading({
					lock: true,
					text: '导入中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				try {
					let res = await ActivityImport(formData);
					if (res.data && Array.isArray(res.data) && res.data.length > 0) {
						this.$alert(res.data.join('<br/>'), '提示', {
							dangerouslyUseHTMLString: true
						});
					} else {
						this.$message.success(res.message || '导入成功');
						this.$emit('reload');
					}
				} catch (err) {
					this.$message.error('导入出错');
				} finally {
					loading.close();
					this.$refs.fileInput.value = '';
				}
			},
			async exportData() {
				const loading = this.$loading({
					lock: true,
					text: '导出中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				try {
					// Need to pass search params. Since this component doesn't have them, 
					// the parent should handle export or we emit an event.
					// But I put the button here.
					// I'll emit an event 'export' and let parent handle it?
					// Or I can use $parent.form? No, that's coupling.
					// Let's emit 'Export'.
					this.$emit('Export'); // Parent ActivityList.vue should handle API call or pass params back?
					// Wait, in ActivityList.vue I didn't implement 'Export' handler fully.
					// I should move Export logic to Parent or pass params to Table.
					// Let's assume parent handles it.
				} finally {
					loading.close();
				}
			},
			async downloadTemplate() {
				let res = await ActivityDownloadTemplet({});
				if (res.code === 0) {
					window.location.href = res.data;
				} else {
					this.$message.warning("下载失败");
				}
			},
			hold() {
				if (this.selection.length !== 1) {
					this.$message.warning('请选择一条数据进行举办');
					return;
				}

				if (this.selection[0].RecordCount != 0) {
					this.$message.warning('该活动已举办，不可重复举办');
					return;
				}

				this.dialogVisibleConduct = true;
				this.$nextTick(() => {
					this.$refs.conductDialog.init(this.selection[0].ActivityCode);
				});
			},
			cancelConduct() {
				this.dialogVisibleConduct = false;
			},
			dialogOKConduct() {
				this.dialogVisibleConduct = false;
				this.$emit('reload');
			}
		}
	};
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		.from {
			width: 100%;
		}

		.Dowload {
			display: inline-block;
			font-size: 14px;
			margin-left: 10px;
			color: #00266D;
			text-decoration: underline;
			cursor: pointer;
		}
	}
</style>